import { Amount, Text } from '@razorpay/blade/components';

import { useEmployeeSalaryDetails } from 'components/PayDetails/hooks/useEmployeeSalaryDetails';
import { AssignedFlexibleComponentsTableDataType } from 'components/PayDetails/types';
import { getPercentageValue, isFBPUnitAmount } from 'components/PayDetails/utils';
import React from 'react';

export const YearlyAmountColumn = ({
  rowData,
  monthlyDeclarationValue,
}: {
  rowData: AssignedFlexibleComponentsTableDataType;
  monthlyDeclarationValue: string;
}) => {
  const isAmount = isFBPUnitAmount(rowData.unit);
  const { totalAnnualCTC, totalBase } = useEmployeeSalaryDetails();

  const baseValue =
    rowData?.unit === 'PERCENTAGE_OF_CTC' || rowData?.unit === 'PERCENTAGE_OF_GROSS'
      ? totalAnnualCTC
      : rowData?.unit === 'PERCENTAGE_OF_BASIC'
      ? totalBase
      : '0';

  const amountToShow = isAmount
    ? Number(monthlyDeclarationValue) * 12
    : getPercentageValue(Number(baseValue), Number(monthlyDeclarationValue));
  const roundedAmount = Math.round(amountToShow);
  return (
    <Text>
      <Amount value={roundedAmount} />
    </Text>
  );
};
